module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_02_beach-photo-87036e593f2a7538d8ff4cdcf6c987a3.jpg";